import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import Maintenance from "./views/Maintenance.vue";

//plugins
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import IsDemo from "./plugins/isDemo";
import moment from "moment";
import { i18n } from "@/plugins/i18n";

import "./assets/css/style.css";

// router&store setup
import router from "./router";
import store from "./store";

const maintenanceRaw = process.env.VUE_APP_MAINTENANCE_MODE;
const isMaintenanceMode =
  String(maintenanceRaw || "").toLowerCase() === "true" ||
  maintenanceRaw === "1";
// plugin setup
Vue.config.productionTip = false;
Vue.prototype.moment = moment;
//Vue.use(VueI18n);
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: "head" });

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   render: h => h(App),
//   router
// });
/* eslint-disable no-new */
const app = new Vue({
  ...(isMaintenanceMode
    ? {}
    : {
        router,
        store,
        i18n,
      }),
  el: "#app",
  render: (h) => h(isMaintenanceMode ? Maintenance : App),
});

if (!isMaintenanceMode) {
  store.$app = app;
}
